import { render, staticRenderFns } from "./EventFlowLocationHeader.vue?vue&type=template&id=05c35f87&scoped=true"
import script from "./EventFlowLocationHeader.vue?vue&type=script&lang=ts"
export * from "./EventFlowLocationHeader.vue?vue&type=script&lang=ts"
import style0 from "./EventFlowLocationHeader.vue?vue&type=style&index=0&id=05c35f87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c35f87",
  null
  
)

export default component.exports